A code classifying the primary method of payment for a position.

Currently, three codes are defined:

- `Hourly` employment is paid for the number of hours worked.

- `Salaried` employment is paid on a monthly or annual basis.

- `SalariedPlusCommission` employment is paid on an annual basis plus a results-based commission.
